import { type ThunkDispatch } from "@reduxjs/toolkit"
import { type UnknownAction } from "redux"

import {
  type HandledError,
  type HandledErrorOptions,
  type HandledErrorSource,
  createHandledError
} from "../../errors/handled-error"
import { reportHandledError } from "../../observability/handled-errors"
import { errorSave } from "../../redux/errors.slice"

type Dispatch = ThunkDispatch<unknown, unknown, UnknownAction>

export const buildHandledError = (
  response: HandledErrorSource | null | undefined,
  options: HandledErrorOptions
): HandledError => {
  const error = createHandledError(response ?? {}, options)
  reportHandledError(error)
  return error
}

export const saveHandledError = (
  response: HandledErrorSource | null | undefined,
  dispatch: Dispatch,
  options: HandledErrorOptions
): HandledError => {
  const error = buildHandledError(response, options)
  dispatch(errorSave(error))
  return error
}

export const rejectWithHandledError = <R>(
  response: HandledErrorSource | null | undefined,
  {
    dispatch,
    rejectWithValue,
    rejectValue,
    ...options
  }: HandledErrorOptions & {
    dispatch: Dispatch
    rejectWithValue: (value: unknown) => R
    rejectValue?: unknown
  }
): R => {
  saveHandledError(response, dispatch, options)
  return rejectWithValue(
    rejectValue === undefined ? (response?.data ?? null) : rejectValue
  )
}
